// reducers/msedclReducer.js
import {
  MSEDCL_CA_FORM_REQUEST,
  MSEDCL_CA_FORM_SUCCESS,
  MSEDCL_CA_FORM_FAILURE,
  MSEDCL_FETCH_COMPLAINT_TYPES_REQUEST,
  MSEDCL_FETCH_COMPLAINT_TYPES_SUCCESS,
  MSEDCL_FETCH_COMPLAINT_TYPES_FAILURE,
  MSEDCL_REGISTER_COMPLAIN_REQUEST,
  MSEDCL_REGISTER_COMPLAIN_SUCCESS,
  MSEDCL_REGISTER_COMPLAIN_FAILURE,
  MSEDCL_INIT_PAYMENT_REQUEST,
  MSEDCL_INIT_PAYMENT_SUCCESS,
  MSEDCL_INIT_PAYMENT_FAILURE,
  MSEDCL_TRACK_COMPLAINT_STATUS_REQUEST,
  MSEDCL_TRACK_COMPLAINT_STATUS_SUCCESS,
  MSEDCL_TRACK_COMPLAINT_STATUS_FAILURE,
  MSEDCL_GOGREEN_STATUS_REQUEST,
  MSEDCL_GOGREEN_STATUS_SUCCESS,
  MSEDCL_GOGREEN_STATUS_FAILURE,
  MSEDCL_GOGREEN_SUBSCRIBE_REQUEST,
  MSEDCL_GOGREEN_SUBSCRIBE_SUCCESS,
  MSEDCL_GOGREEN_SUBSCRIBE_FAILURE,
  MSEDCL_GOGREEN_UNSUBSCRIBE_REQUEST,
  MSEDCL_GOGREEN_UNSUBSCRIBE_SUCCESS,
  MSEDCL_GOGREEN_UNSUBSCRIBE_FAILURE,
  MSEDCL_CONSUMER_DETAILS_REQUEST,
  MSEDCL_CONSUMER_DETAILS_SUCCESS,
  MSEDCL_CONSUMER_DETAILS_FAILURE,
  MSEDCL_DEACTIVATE_SUBSCRIPTION_REQUEST,
  MSEDCL_DEACTIVATE_SUBSCRIPTION_SUCCESS,
  MSEDCL_DEACTIVATE_SUBSCRIPTION_FAILURE,
  MSEDCL_TRACKING_APPLICATIONS_REQUEST,
  MSEDCL_TRACKING_APPLICATIONS_SUCCESS,
  MSEDCL_TRACKING_APPLICATIONS_FAILURE,
  MSEDCL_CUSTOMER_ACCOUNTS_REQUEST,
  MSEDCL_CUSTOMER_ACCOUNTS_SUCCESS,
  MSEDCL_CUSTOMER_ACCOUNTS_FAILURE,
  MSEDCL_GET_APPLICATION_BY_ID_REQUEST,
  MSEDCL_GET_APPLICATION_BY_ID_SUCCESS,
  MSEDCL_GET_APPLICATION_BY_ID_FAILURE,
  MSEDCL_SERVICE_REQUEST_DETAILS_REQUEST,
  MSEDCL_SERVICE_REQUEST_DETAILS_SUCCESS,
  MSEDCL_SERVICE_REQUEST_DETAILS_FAILURE,
  MSEDCL_DISTRICT_LIST_REQUEST,
  MSEDCL_DISTRICT_LIST_SUCCESS,
  MSEDCL_DISTRICT_LIST_FAILURE,
  MSEDCL_TALUKA_LIST_REQUEST,
  MSEDCL_TALUKA_LIST_SUCCESS,
  MSEDCL_TALUKA_LIST_FAILURE,
  MSEDCL_VILLAGE_LIST_REQUEST,
  MSEDCL_VILLAGE_LIST_SUCCESS,
  MSEDCL_VILLAGE_LIST_FAILURE,
  MSEDCL_PINCODE_LIST_REQUEST,
  MSEDCL_PINCODE_LIST_SUCCESS,
  MSEDCL_PINCODE_LIST_FAILURE,
  MSEDCL_SUBMIT_ADDRESS_REQUEST,
  MSEDCL_SUBMIT_ADDRESS_SUCCESS,
  MSEDCL_SUBMIT_ADDRESS_FAILURE,
  MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_REQUEST,
  MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_SUCCESS,
  MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_FAILURE,
  MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_REQUEST,
  MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_SUCCESS,
  MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_FAILURE,
  MSEDCL_TARIFF_ACTIVITY_LIST_REQUEST,
  MSEDCL_TARIFF_ACTIVITY_LIST_SUCCESS,
  MSEDCL_TARIFF_ACTIVITY_LIST_FAILURE,
  MSEDCL_SUBMIT_TARIFF_CHANGE_REQUEST,
  MSEDCL_SUBMIT_TARIFF_CHANGE_SUCCESS,
  MSEDCL_SUBMIT_TARIFF_CHANGE_FAILURE,
  MSEDCL_GET_SALARY_SLIP_REQUEST,
  MSEDCL_GET_SALARY_SLIP_SUCCESS,
  MSEDCL_GET_SALARY_SLIP_FAILURE,
  MSEDCL_GET_EMPLOYEE_DETAILS_REQUEST,
  MSEDCL_GET_EMPLOYEE_DETAILS_SUCCESS,
  MSEDCL_GET_EMPLOYEE_DETAILS_FAILURE,
  MSEDCL_FEEDBACK_DETAILS_REQUEST,
  MSEDCL_FEEDBACK_DETAILS_SUCCESS,
  MSEDCL_FEEDBACK_DETAILS_FAILURE,
  MSEDCL_SUBMIT_FEEDBACK_REQUEST,
  MSEDCL_SUBMIT_FEEDBACK_SUCCESS,
  MSEDCL_SUBMIT_FEEDBACK_FAILURE,
} from "../actions/msedclAction";

const initialState = {
  msedcl_ca_form_loading: false,
  msedcl_ca_form_data: null,
  msedcl_ca_form_error: null,
  msedcl_complaint_types_loading: false,
  msedcl_complaint_types_data: {
    major_type: null,
    request_type: null,
    sub_request_type: null,
  },
  msedcl_complaint_types_error: null,
  msedcl_register_complain_loading: false,
  msedcl_register_complain_data: null,
  msedcl_register_complain_error: null,
  msedcl_payment_loading: false,
  msedcl_payment_data: null,
  msedcl_payment_error: null,
  msedcl_track_complaint_status_loading: false,
  msedcl_track_complaint_status_data: null,
  msedcl_track_complaint_status_error: null,
  msedcl_gogreen_status_loading: false,
  msedcl_gogreen_status_data: null,
  msedcl_gogreen_status_error: null,
  msedcl_gogreen_subscribe_loading: false,
  msedcl_gogreen_subscribe_data: null,
  msedcl_gogreen_subscribe_error: null,
  msedcl_gogreen_unsubscribe_loading: false,
  msedcl_gogreen_unsubscribe_data: null,
  msedcl_gogreen_unsubscribe_error: null,
  msedcl_consumer_details_loading: false,
  msedcl_consumer_details_data: null,
  msedcl_consumer_details_error: null,
  msedcl_deactivate_subscription_loading: false,
  msedcl_deactivate_subscription_data: null,
  msedcl_deactivate_subscription_error: null,
  msedcl_tracking_applications_loading: false,
  msedcl_tracking_applications_data: null,
  msedcl_tracking_applications_error: null,
  msedcl_customer_accounts_loading: false,
  msedcl_customer_accounts_data: null,
  msedcl_customer_accounts_error: null,
  msedcl_application_by_id_loading: false,
  msedcl_application_by_id_data: null,
  msedcl_application_by_id_error: null,
  msedcl_service_request_details_loading: false,
  msedcl_service_request_details_data: null,
  msedcl_service_request_details_error: null,
  msedcl_district_list_loading: false,
  msedcl_district_list_data: null,
  msedcl_district_list_error: null,
  msedcl_taluka_list_loading: false,
  msedcl_taluka_list_data: null,
  msedcl_taluka_list_error: null,
  msedcl_village_list_loading: false,
  msedcl_village_list_data: null,
  msedcl_village_list_error: null,
  msedcl_pincode_list_loading: false,
  msedcl_pincode_list_data: null,
  msedcl_pincode_list_error: null,
  msedcl_submit_address_loading: false,
  msedcl_submit_address_data: null,
  msedcl_submit_address_error: null,
  msedcl_tariff_activity_type_list_loading: false,
  msedcl_tariff_activity_type_list_data: null,
  msedcl_tariff_activity_type_list_error: null,
  msedcl_tariff_activity_group_list_loading: false,
  msedcl_tariff_activity_group_list_data: null,
  msedcl_tariff_activity_group_list_error: null,
  msedcl_tariff_activity_list_loading: false,
  msedcl_tariff_activity_list_data: null,
  msedcl_tariff_activity_list_error: null,
  msedcl_submit_tariff_loading: false,
  msedcl_submit_tariff_data: null,
  msedcl_submit_tariff_error: null,
  msedcl_salary_slip_loading: false,
  msedcl_salary_slip_data: null,
  msedcl_salary_slip_error: null,
  msedcl_employee_details_loading: false,
  msedcl_employee_details_data: null,
  msedcl_employee_details_error: null,
  msedcl_feedback_details_loading: false,
  msedcl_feedback_details_data: null,
  msedcl_feedback_details_error: null,
  msedcl_submit_feedback_loading: false,
  msedcl_submit_feedback_data: null,
  msedcl_submit_feedback_error: null,
};

const msedclReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- CA Form ---
    case MSEDCL_CA_FORM_REQUEST:
      return { ...state, msedcl_ca_form_loading: true, msedcl_ca_form_error: null };
    case MSEDCL_CA_FORM_SUCCESS:
      return { ...state, msedcl_ca_form_loading: false, msedcl_ca_form_data: action.payload };
    case MSEDCL_CA_FORM_FAILURE:
      return { ...state, msedcl_ca_form_loading: false, msedcl_ca_form_error: action.payload };
    case "CLEAR_MSEDCL_CA_FORM_DATA":
      return { ...state, msedcl_ca_form_data: null };

    // --- Complaint Types ---
    case MSEDCL_FETCH_COMPLAINT_TYPES_REQUEST:
      return { ...state, msedcl_complaint_types_loading: true, msedcl_complaint_types_error: null };
    case MSEDCL_FETCH_COMPLAINT_TYPES_SUCCESS:
      return {
        ...state,
        msedcl_complaint_types_loading: false,
        msedcl_complaint_types_data: {
          ...state.msedcl_complaint_types_data,
          [action.payload.mode]: action.payload,
        },
      };
    case MSEDCL_FETCH_COMPLAINT_TYPES_FAILURE:
      return {
        ...state,
        msedcl_complaint_types_loading: false,
        msedcl_complaint_types_error: action.payload,
      };
    case "CLEAR_MSEDCL_COMPLAINT_TYPES_DATA":
      return { 
        ...state, 
        msedcl_complaint_types_data: {
          major_type: null,
          request_type: null,
          sub_request_type: null,
        }
      };

    // --- Register Complain ---
    case MSEDCL_REGISTER_COMPLAIN_REQUEST:
      return { ...state, msedcl_register_complain_loading: true, msedcl_register_complain_error: null };
    case MSEDCL_REGISTER_COMPLAIN_SUCCESS:
      return {
        ...state,
        msedcl_register_complain_loading: false,
        msedcl_register_complain_data: action.payload,
      };
    case MSEDCL_REGISTER_COMPLAIN_FAILURE:
      return {
        ...state,
        msedcl_register_complain_loading: false,
        msedcl_register_complain_error: action.payload,
      };
    case "CLEAR_MSEDCL_REGISTER_COMPLAIN_DATA":
      return { ...state, msedcl_register_complain_data: null };

    // --- Payment ---
    case MSEDCL_INIT_PAYMENT_REQUEST:
      return { ...state, msedcl_payment_loading: true, msedcl_payment_error: null };
    case MSEDCL_INIT_PAYMENT_SUCCESS:
      return { ...state, msedcl_payment_loading: false, msedcl_payment_data: action.payload };
    case MSEDCL_INIT_PAYMENT_FAILURE:
      return { ...state, msedcl_payment_loading: false, msedcl_payment_error: action.payload };
    case "CLEAR_MSEDCL_PAYMENT_DATA":
      return { ...state, msedcl_payment_data: null };

    // --- Track Complaint Status ---
    case MSEDCL_TRACK_COMPLAINT_STATUS_REQUEST:
      return { ...state, msedcl_track_complaint_status_loading: true, msedcl_track_complaint_status_error: null };
    case MSEDCL_TRACK_COMPLAINT_STATUS_SUCCESS:
      return {
        ...state,
        msedcl_track_complaint_status_loading: false,
        msedcl_track_complaint_status_data: action.payload,
      };
    case MSEDCL_TRACK_COMPLAINT_STATUS_FAILURE:
      return {
        ...state,
        msedcl_track_complaint_status_loading: false,
        msedcl_track_complaint_status_error: action.payload,
      };
    case "CLEAR_MSEDCL_TRACK_COMPLAINT_STATUS_DATA":
      return { ...state, msedcl_track_complaint_status_data: null };

    // --- Go Green Status ---
    case MSEDCL_GOGREEN_STATUS_REQUEST:
      return { ...state, msedcl_gogreen_status_loading: true, msedcl_gogreen_status_error: null };
    case MSEDCL_GOGREEN_STATUS_SUCCESS:
      return { ...state, msedcl_gogreen_status_loading: false, msedcl_gogreen_status_data: action.payload };
    case MSEDCL_GOGREEN_STATUS_FAILURE:
      return { ...state, msedcl_gogreen_status_loading: false, msedcl_gogreen_status_error: action.payload };
    case "CLEAR_MSEDCL_GOGREEN_STATUS_DATA":
      return { ...state, msedcl_gogreen_status_data: null };

    // --- Go Green Subscribe ---
    case MSEDCL_GOGREEN_SUBSCRIBE_REQUEST:
      return { ...state, msedcl_gogreen_subscribe_loading: true, msedcl_gogreen_subscribe_error: null };
    case MSEDCL_GOGREEN_SUBSCRIBE_SUCCESS:
      return { ...state, msedcl_gogreen_subscribe_loading: false, msedcl_gogreen_subscribe_data: action.payload };
    case MSEDCL_GOGREEN_SUBSCRIBE_FAILURE:
      return { ...state, msedcl_gogreen_subscribe_loading: false, msedcl_gogreen_subscribe_error: action.payload };
    case "CLEAR_MSEDCL_GOGREEN_SUBSCRIBE_DATA":
      return { ...state, msedcl_gogreen_subscribe_data: null };

    // --- Go Green Unsubscribe ---
    case MSEDCL_GOGREEN_UNSUBSCRIBE_REQUEST:
      return { ...state, msedcl_gogreen_unsubscribe_loading: true, msedcl_gogreen_unsubscribe_error: null };
    case MSEDCL_GOGREEN_UNSUBSCRIBE_SUCCESS:
      return { ...state, msedcl_gogreen_unsubscribe_loading: false, msedcl_gogreen_unsubscribe_data: action.payload };
    case MSEDCL_GOGREEN_UNSUBSCRIBE_FAILURE:
      return { ...state, msedcl_gogreen_unsubscribe_loading: false, msedcl_gogreen_unsubscribe_error: action.payload };
    case "CLEAR_MSEDCL_GOGREEN_UNSUBSCRIBE_DATA":
      return { ...state, msedcl_gogreen_unsubscribe_data: null };

    // --- Consumer Details ---
    case MSEDCL_CONSUMER_DETAILS_REQUEST:
      return { ...state, msedcl_consumer_details_loading: true, msedcl_consumer_details_error: null };
    case MSEDCL_CONSUMER_DETAILS_SUCCESS:
      return { ...state, msedcl_consumer_details_loading: false, msedcl_consumer_details_data: action.payload };
    case MSEDCL_CONSUMER_DETAILS_FAILURE:
      return { ...state, msedcl_consumer_details_loading: false, msedcl_consumer_details_error: action.payload };
    case "CLEAR_MSEDCL_CONSUMER_DETAILS_DATA":
      return { ...state, msedcl_consumer_details_data: null };

    // --- Deactivate Subscription ---
    case MSEDCL_DEACTIVATE_SUBSCRIPTION_REQUEST:
      return { ...state, msedcl_deactivate_subscription_loading: true, msedcl_deactivate_subscription_error: null };
    case MSEDCL_DEACTIVATE_SUBSCRIPTION_SUCCESS:
      return { ...state, msedcl_deactivate_subscription_loading: false, msedcl_deactivate_subscription_data: action.payload };
    case MSEDCL_DEACTIVATE_SUBSCRIPTION_FAILURE:
      return { ...state, msedcl_deactivate_subscription_loading: false, msedcl_deactivate_subscription_error: action.payload };
    case "CLEAR_MSEDCL_DEACTIVATE_SUBSCRIPTION_DATA":
      return { ...state, msedcl_deactivate_subscription_data: null };

    // --- Tracking Applications (dropdown list) ---
    case MSEDCL_TRACKING_APPLICATIONS_REQUEST:
      return { ...state, msedcl_tracking_applications_loading: true, msedcl_tracking_applications_error: null };
    case MSEDCL_TRACKING_APPLICATIONS_SUCCESS:
      return { ...state, msedcl_tracking_applications_loading: false, msedcl_tracking_applications_data: action.payload };
    case MSEDCL_TRACKING_APPLICATIONS_FAILURE:
      return { ...state, msedcl_tracking_applications_loading: false, msedcl_tracking_applications_error: action.payload };
    case "CLEAR_MSEDCL_TRACKING_APPLICATIONS_DATA":
      return { ...state, msedcl_tracking_applications_data: null };

    // --- Customer Accounts (Home) ---
    case MSEDCL_CUSTOMER_ACCOUNTS_REQUEST:
      return { ...state, msedcl_customer_accounts_loading: true, msedcl_customer_accounts_error: null };
    case MSEDCL_CUSTOMER_ACCOUNTS_SUCCESS:
      return { ...state, msedcl_customer_accounts_loading: false, msedcl_customer_accounts_data: action.payload };
    case MSEDCL_CUSTOMER_ACCOUNTS_FAILURE:
      return { ...state, msedcl_customer_accounts_loading: false, msedcl_customer_accounts_error: action.payload };

    // --- Get Application By ID (Track Your Application) ---
    case MSEDCL_GET_APPLICATION_BY_ID_REQUEST:
      return { ...state, msedcl_application_by_id_loading: true, msedcl_application_by_id_error: null };
    case MSEDCL_GET_APPLICATION_BY_ID_SUCCESS:
      return { ...state, msedcl_application_by_id_loading: false, msedcl_application_by_id_data: action.payload };
    case MSEDCL_GET_APPLICATION_BY_ID_FAILURE:
      return { ...state, msedcl_application_by_id_loading: false, msedcl_application_by_id_error: action.payload };
    case "CLEAR_MSEDCL_APPLICATION_BY_ID_DATA":
      return { ...state, msedcl_application_by_id_data: null, msedcl_application_by_id_error: null };

    // --- Service Request Details (list for Track Complaint Status) ---
    case MSEDCL_SERVICE_REQUEST_DETAILS_REQUEST:
      return { ...state, msedcl_service_request_details_loading: true, msedcl_service_request_details_error: null };
    case MSEDCL_SERVICE_REQUEST_DETAILS_SUCCESS:
      return { ...state, msedcl_service_request_details_loading: false, msedcl_service_request_details_data: action.payload };
    case MSEDCL_SERVICE_REQUEST_DETAILS_FAILURE:
      return { ...state, msedcl_service_request_details_loading: false, msedcl_service_request_details_error: action.payload };
    case "CLEAR_MSEDCL_SERVICE_REQUEST_DETAILS_DATA":
      return { ...state, msedcl_service_request_details_data: null };

    // --- Change Address District List ---
    case MSEDCL_DISTRICT_LIST_REQUEST:
      return { ...state, msedcl_district_list_loading: true, msedcl_district_list_error: null };
    case MSEDCL_DISTRICT_LIST_SUCCESS:
      return { ...state, msedcl_district_list_loading: false, msedcl_district_list_data: action.payload };
    case MSEDCL_DISTRICT_LIST_FAILURE:
      return { ...state, msedcl_district_list_loading: false, msedcl_district_list_error: action.payload };

    // --- Change Address Taluka List ---
    case MSEDCL_TALUKA_LIST_REQUEST:
      return { ...state, msedcl_taluka_list_loading: true, msedcl_taluka_list_error: null };
    case MSEDCL_TALUKA_LIST_SUCCESS:
      return { ...state, msedcl_taluka_list_loading: false, msedcl_taluka_list_data: action.payload };
    case MSEDCL_TALUKA_LIST_FAILURE:
      return { ...state, msedcl_taluka_list_loading: false, msedcl_taluka_list_error: action.payload };

    // --- Change Address Village List ---
    case MSEDCL_VILLAGE_LIST_REQUEST:
      return { ...state, msedcl_village_list_loading: true, msedcl_village_list_error: null };
    case MSEDCL_VILLAGE_LIST_SUCCESS:
      return { ...state, msedcl_village_list_loading: false, msedcl_village_list_data: action.payload };
    case MSEDCL_VILLAGE_LIST_FAILURE:
      return { ...state, msedcl_village_list_loading: false, msedcl_village_list_error: action.payload };

    // --- Change Address Pincode List ---
    case MSEDCL_PINCODE_LIST_REQUEST:
      return { ...state, msedcl_pincode_list_loading: true, msedcl_pincode_list_error: null };
    case MSEDCL_PINCODE_LIST_SUCCESS:
      return { ...state, msedcl_pincode_list_loading: false, msedcl_pincode_list_data: action.payload };
    case MSEDCL_PINCODE_LIST_FAILURE:
      return { ...state, msedcl_pincode_list_loading: false, msedcl_pincode_list_error: action.payload };

    // --- Change Address Submit ---
    case MSEDCL_SUBMIT_ADDRESS_REQUEST:
      return { ...state, msedcl_submit_address_loading: true, msedcl_submit_address_error: null };
    case MSEDCL_SUBMIT_ADDRESS_SUCCESS:
      return { ...state, msedcl_submit_address_loading: false, msedcl_submit_address_data: action.payload };
    case MSEDCL_SUBMIT_ADDRESS_FAILURE:
      return { ...state, msedcl_submit_address_loading: false, msedcl_submit_address_error: action.payload };
    case "CLEAR_MSEDCL_SUBMIT_ADDRESS_DATA":
      return { ...state, msedcl_submit_address_data: null };

    // --- Tariff Activity Type List ---
    case MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_REQUEST:
      return { ...state, msedcl_tariff_activity_type_list_loading: true, msedcl_tariff_activity_type_list_error: null };
    case MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_SUCCESS:
      return { ...state, msedcl_tariff_activity_type_list_loading: false, msedcl_tariff_activity_type_list_data: action.payload };
    case MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_FAILURE:
      return { ...state, msedcl_tariff_activity_type_list_loading: false, msedcl_tariff_activity_type_list_error: action.payload };

    // --- Tariff Activity Group List ---
    case MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_REQUEST:
      return { ...state, msedcl_tariff_activity_group_list_loading: true, msedcl_tariff_activity_group_list_error: null };
    case MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_SUCCESS:
      return { ...state, msedcl_tariff_activity_group_list_loading: false, msedcl_tariff_activity_group_list_data: action.payload };
    case MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_FAILURE:
      return { ...state, msedcl_tariff_activity_group_list_loading: false, msedcl_tariff_activity_group_list_error: action.payload };

    // --- Tariff Activity List ---
    case MSEDCL_TARIFF_ACTIVITY_LIST_REQUEST:
      return { ...state, msedcl_tariff_activity_list_loading: true, msedcl_tariff_activity_list_error: null };
    case MSEDCL_TARIFF_ACTIVITY_LIST_SUCCESS:
      return { ...state, msedcl_tariff_activity_list_loading: false, msedcl_tariff_activity_list_data: action.payload };
    case MSEDCL_TARIFF_ACTIVITY_LIST_FAILURE:
      return { ...state, msedcl_tariff_activity_list_loading: false, msedcl_tariff_activity_list_error: action.payload };

    // --- Submit Tariff Change ---
    case MSEDCL_SUBMIT_TARIFF_CHANGE_REQUEST:
      return { ...state, msedcl_submit_tariff_loading: true, msedcl_submit_tariff_error: null };
    case MSEDCL_SUBMIT_TARIFF_CHANGE_SUCCESS:
      return { ...state, msedcl_submit_tariff_loading: false, msedcl_submit_tariff_data: action.payload };
    case MSEDCL_SUBMIT_TARIFF_CHANGE_FAILURE:
      return { ...state, msedcl_submit_tariff_loading: false, msedcl_submit_tariff_error: action.payload };
    case "CLEAR_MSEDCL_SUBMIT_TARIFF_DATA":
      return { ...state, msedcl_submit_tariff_data: null };

    // --- Get Salary Slip ---
    case MSEDCL_GET_SALARY_SLIP_REQUEST:
      return { ...state, msedcl_salary_slip_loading: true, msedcl_salary_slip_error: null };
    case MSEDCL_GET_SALARY_SLIP_SUCCESS:
      return { ...state, msedcl_salary_slip_loading: false, msedcl_salary_slip_data: action.payload };
    case MSEDCL_GET_SALARY_SLIP_FAILURE:
      return { ...state, msedcl_salary_slip_loading: false, msedcl_salary_slip_error: action.payload };
    case "CLEAR_MSEDCL_SALARY_SLIP_DATA":
      return { ...state, msedcl_salary_slip_data: null };

    // --- Get Employee Details By Mobile (Update Profile) ---
    case MSEDCL_GET_EMPLOYEE_DETAILS_REQUEST:
      return { ...state, msedcl_employee_details_loading: true, msedcl_employee_details_error: null };
    case MSEDCL_GET_EMPLOYEE_DETAILS_SUCCESS:
      return { ...state, msedcl_employee_details_loading: false, msedcl_employee_details_data: action.payload };
    case MSEDCL_GET_EMPLOYEE_DETAILS_FAILURE:
      return { ...state, msedcl_employee_details_loading: false, msedcl_employee_details_error: action.payload };
    case "CLEAR_MSEDCL_EMPLOYEE_DETAILS_DATA":
      return { ...state, msedcl_employee_details_data: null };

    // --- Consumer Closure Feedback Details ---
    case MSEDCL_FEEDBACK_DETAILS_REQUEST:
      return { ...state, msedcl_feedback_details_loading: true, msedcl_feedback_details_error: null };
    case MSEDCL_FEEDBACK_DETAILS_SUCCESS:
      return { ...state, msedcl_feedback_details_loading: false, msedcl_feedback_details_data: action.payload };
    case MSEDCL_FEEDBACK_DETAILS_FAILURE:
      return { ...state, msedcl_feedback_details_loading: false, msedcl_feedback_details_error: action.payload };

    // --- Consumer Closure Submit Feedback ---
    case MSEDCL_SUBMIT_FEEDBACK_REQUEST:
      return { ...state, msedcl_submit_feedback_loading: true, msedcl_submit_feedback_error: null };
    case MSEDCL_SUBMIT_FEEDBACK_SUCCESS:
      return { ...state, msedcl_submit_feedback_loading: false, msedcl_submit_feedback_data: action.payload };
    case MSEDCL_SUBMIT_FEEDBACK_FAILURE:
      return { ...state, msedcl_submit_feedback_loading: false, msedcl_submit_feedback_error: action.payload };

    default:
      return state;
  }
};

export default msedclReducer;

